import React from 'react'
import DocumentList from './index'

type AppProps={
  history:any
}

const SearchFileManager = ({history}:AppProps) => {
  return (
   <DocumentList history={history}/>
  )
}

export default SearchFileManager